// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1200":"bbd39abec4b0b05b","5439":"c975d2013ec8d6ef","7320":"2c96ead5a9f64639"}[chunkId] + ".js";
};